var _effectorFileName = "/src/widgets/layouts/main/call-to-action/call-to-action.tsx";
import Link from 'next/link';
import { REVIEWS_LIST } from '@/widgets/layouts/main/constants/reviews';
import { TextShimmerAnimation } from '@/shared/components/animation/text-shimmer';
import { Article } from '@/shared/components/article';
import ArrowIcon from '@/shared/components/icons/arrow-icon';
import HeartIcon from '@/shared/components/icons/heart-icon';
import GmailIcon from '@/shared/components/icons/socials/gmail-icon';
import LinkedInIcon from '@/shared/components/icons/socials/linkedin-icon';
import TelegramIcon from '@/shared/components/icons/socials/telegram-icon';
import { Marquee } from '@/shared/components/marquee';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/lib/cn';
import { ReviewCard } from '../reviews/review-card';
interface CallToActionProps {
  header?: string;
  description?: string;
  link?: string;
}
export const CallToAction = (props: CallToActionProps) => {
  const {
    header = 'Sign up for a consultation',
    description,
    link
  } = props;
  return <Article>
      <div className={cn('relative flex w-full flex-col items-center justify-center overflow-hidden rounded-xl border p-4 py-6 sm:rounded-[2rem] sm:p-10 sm:py-14')}>
        <div className="absolute rotate-[35deg]">
          <Marquee>
            {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={review.text} author={review.author} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
          </Marquee>

          <Marquee reverse>
            {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={review.text} author={review.author} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
          </Marquee>

          <div className="hidden sm:block">
            <Marquee>
              {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={review.text} author={review.author} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
            </Marquee>

            <Marquee reverse>
              {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={review.text} author={review.author} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
            </Marquee>

            <Marquee>
              {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={review.text} author={review.author} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
            </Marquee>

            <Marquee reverse>
              {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={review.text} author={review.author} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
            </Marquee>
          </div>
        </div>

        <div className="z-10 grid size-24 place-items-center rounded-[2rem] border bg-white/10 p-3 shadow-2xl backdrop-blur-md dark:bg-black/10 lg:size-32">
          <HeartIcon className="h-5/6 w-5/6" />
        </div>

        <div className="z-10 mt-4 flex flex-col items-center text-center text-black dark:text-white">
          <h2 className="text-2xl font-bold lg:text-4xl">{header}</h2>

          <p className="mt-2 max-w-2xl text-sm sm:text-base">
            {description ?? 'We will help your employees become confident in English'}
          </p>

          <Link href={process.env.NEXT_PUBLIC_CALENDLY_URL} rel="noopener noreferrer" target="_blank" aria-label="Company Calendly">
            <Button className="mt-6" type="button" variant="cta" aria-label="Book a call with CEO">
              <span>Book a call with our CEO</span>
            </Button>
          </Link>

          {link ? <Link href={link} aria-label="Contact us">
              <Button size="link" className="group mt-4 flex items-center justify-center rounded-[2rem] border border-brand-accent-light bg-background px-6 text-sm font-medium shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" aria-label="Contact us">
                <TextShimmerAnimation className="flex items-center justify-center">
                  Contact
                  <ArrowIcon className="ml-1 size-4 transition-all duration-300 ease-out group-hover:translate-x-1" />
                </TextShimmerAnimation>
              </Button>
            </Link> : <div className="mt-4 flex items-center gap-4">
              <Link aria-label="Visit Enlerno Telegram" href={process.env.NEXT_PUBLIC_TG_URL} target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent-normal dark:hover:text-brand-accent-light">
                <TelegramIcon className="h-8 w-8" />
              </Link>

              <Link aria-label="Visit Enlerno Linkedin" href={process.env.NEXT_PUBLIC_LINKEDIN_URL} target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent-normal dark:hover:text-brand-accent-light">
                <LinkedInIcon className="h-8 w-8" />
              </Link>

              <Link aria-label="Write an email" href={`mailto:${process.env.NEXT_PUBLIC_GMAIL}`} target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent-normal dark:hover:text-brand-accent-light">
                <GmailIcon className="h-9 w-10" />
              </Link>
            </div>}
        </div>

        <div className="absolute inset-x-0 bottom-0 h-full bg-gradient-to-b from-transparent to-white to-60% dark:to-black sm:to-50%"></div>
      </div>
    </Article>;
};